import React, { useRef } from 'react';
import moment from 'moment';
import { useReactToPrint } from 'react-to-print';
import { Row } from 'reactstrap';

//Context
import { useAuth } from '../../../context/auth';

//Components
import MainCard from '../../../components/MainCard/MainCard';
import CardRelatorio from '../components/CardRelatorio';

//Helpers
import mascaras from '../../../helpers/mascaras';

export default function RelatorioCertificadoBalancaMassa({ dadosRelatorio, btnVoltar, filtros }) {
    const { setupVariavel, session } = useAuth();

    //Referencia do relatorio para impressão pdf
    const refRelatorio = useRef(null);

    //Função assionada assim que o botão de imprimir pdf é clicado
    const handlePrint = useReactToPrint({
        content: () => refRelatorio.current,
        copyStyles: true,
        documentTitle: "Relatório Certificado de Balanço de massa",
    });

    //Cabeçalhos para a listagem das coletas por meio do cardRelatorio
    const headersBalancoMassa = [
        { value: "Modalidade", objectValue: "modalidade", col: "12" },
        { value: "Peso Anterior", objectValue: "pesoAnterior", col: "3" },
        { value: "Peso Entrada", objectValue: "pesoEntrada", col: "3" },
        { value: "Peso Saida", objectValue: "pesoSaida", col: "3" },
        { value: "Peso Acumulado", objectValue: "pesoAcumulado", col: "3" },
    ];


    return <MainCard btnVoltarInTop={btnVoltar} btnImprimir={handlePrint}>
        <div className="mt-4 relatorio w-100" ref={refRelatorio}>
            <div className="print m-2 d-flex align-items-center justify-content-between">
                <p>Emitido por: {session.nome}</p>
                <p>Data de emissão: {moment().format("DD/MM/YYYY HH:mm")}</p>
            </div>
            {setupVariavel?.logoTipo &&
                <div className="d-flex align-items-center justify-content-center">
                    <img src={"data:image/png;base64," + setupVariavel?.logoTipo} style={{ maxWidth: '70%' }} />
                </div>
            }
            <div className="header">
                <h4 className='text-black'>Relatório Certificado de Balanço de Massa</h4>
                <Row>
                    <div className='col-4'>
                        <p><span className="fw-bold">Nome:</span> {dadosRelatorio.nomeDestino}</p>
                    </div>
                    <div className="col-4">
                        <p><span className="fw-bold">CNPJ:</span> {mascaras.cpfcnpjMask(dadosRelatorio?.cnpJ_Destino)}</p>
                    </div>
                    <div className="col-4">
                        <p><span className="fw-bold">Mês/Ano:</span> {dadosRelatorio.mesAno}</p>
                    </div>
                </Row>
            </div>
            <div className="body">               
                <CardRelatorio headers={headersBalancoMassa} items={dadosRelatorio.balancoMassaTipoColetas} />
            </div>
        </div>
    </MainCard>;
}